const formatResultDate = (dateString) => {
  const date = new Date(dateString);
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  return `${month}/${day}, ${String(hours).padStart(2, "0")}:${minutes} ${ampm}`;
};

const BollywoodResult = ({
  resultData
}) => {
  function getCardNumberFunc(card) {
    let secChar1 = card.slice(0, -2);
    if (secChar1 == "A") {
      secChar1 = 1;
    } else if (secChar1 == "J") {
      secChar1 = 11;
    }
    else if (secChar1 == "Q") {
      secChar1 = 12;
    }
    else if (secChar1 == "K") {
      secChar1 = 13;
    }
    return secChar1;
  }
  return (
    <div id="ResultsData" class="tabcontent" style={{ display: "block" }}>
      <div class="left-content" style={{ marginLeft: "5px", marginRight: "5px" }}>
        {resultData &&
          resultData.length > 0 &&
          resultData.map((dataObj, index) => {
            let card = dataObj.c1;
            let imgval1 = `/assets/images/cards/${dataObj.c1}.svg`;

            let cardVal = getCardNumberFunc(dataObj.c1);
            //let firstCharLast2 = dataObj.c1.slice(-2).trim();

            let resultVal = dataObj.result;
            let win1 = 'LOSER';
            let win2 = 'LOSER';
            let win3 = 'LOSER';
            let win4 = 'LOSER';
            let win5 = 'LOSER';
            let win6 = 'LOSER';
            let win7 = 'LOSER';
            let win8 = 'LOSER';
            let win9 = 'LOSER';
            let win10 = 'LOSER';
            let win11 = 'LOSER';
            let win12 = 'LOSER';
            let win13 = 'LOSER';
            let win14 = 'LOSER';

            let reusutlRnr1 = '';
            let reusutlRnr2 = '';
            let reusutlRnr3 = '';
            let reusutlRnr4 = '';

            if (card == 'AHH') {
              win1 = 'WINNER';
              reusutlRnr1 = 'Don';
            } else if (card == 'ASS' || card == 'ACC' || card == 'ADD') {
              win2 = 'WINNER';
              reusutlRnr1 = 'Amar Akbar Anthony';
            } else if (card == 'KHH' || card == 'QHH' || card == 'JHH') {
              win3 = 'WINNER';
              reusutlRnr1 = 'Sahib Bibi Aur Gulam';
            } else if (card == 'KSS' || card == 'KCC') {
              win4 = 'WINNER';
              reusutlRnr1 = 'Dharam Veer';
            } else if (card == 'KDD' || card == 'QCC' || card == 'QSS' || card == 'QDD') {
              win5 = 'WINNER';
              reusutlRnr1 = 'Kis Kisko Pyaar Karoon';
            } else if (card == 'JDD' || card == 'JCC' || card == 'JSS') {
              win6 = 'WINNER';
              reusutlRnr1 = 'Ghulam';
            }

            let firstChar = card.slice(0, -2);
            let firstCharLast2 = card.slice(-2).trim();

            if (firstChar == "K" || firstChar == "Q") {
              win7 = 'WINNER';
              reusutlRnr2 = 'K-Q';
            }
            if (firstChar == "J" || firstChar == "A") {
              win8 = 'WINNER';
              reusutlRnr2 = 'J-A';
            }

            if (firstCharLast2 == "SS" || firstCharLast2 == "DD") {
              win9 = 'WINNER';
              reusutlRnr3 = 'Red';
            }
            if (firstCharLast2 == "HH" || firstCharLast2 == "CC") {
              win10 = 'WINNER';
              reusutlRnr3 = 'Black';
            }

            if (firstChar == "J") {
              win11 = 'WINNER';
              reusutlRnr4 = 'J';
            }
            if (firstChar == "Q") {
              win12 = 'WINNER';
              reusutlRnr4 = 'Q';
            }
            if (firstChar == "K") {
              win13 = 'WINNER';
              reusutlRnr4 = 'K';
            }
            if (firstChar == "A") {
              win14 = 'WINNER';
              reusutlRnr4 = 'A';
            }

            return (
              <div
                class="card"
                style={{
                  border: "1px solid rgb(204, 204, 204)",
                  borderRadius: "8px",
                  boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 8px",
                  marginBottom: "5px",
                  background: "linear-gradient(rgb(15, 15, 15), rgb(251, 251, 251))",
                  color: "white"
                }}
              >
                <div
                  class="card-header"
                  style={{
                    fontWeight: "bold",
                    fontSize: "16px",
                    marginBottom: "7px",
                    marginTop: "10px",
                    marginLeft: "7px",
                    background: "transparent",
                    borderBottom: "solid 1px #000"
                  }}
                >
                  {formatResultDate(dataObj.evt_od)} - <b>ID=</b> {dataObj._id}
                </div>
                <div class="card-body">
                  <div
                    class="players-table"
                    style={{ textAlign: "center", width: "100%" }}
                  >
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <tbody>
                        <tr style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-evenly", background: "transparent" }}>

                          <td class="TdResults">
                            <div class="player-cards" style={{ display: "flex", flexDirection: "column", alignItems: "center", overflowWrap: "break-word" }}>
                              <div class="player-name" style={{ fontWeight: "bold", textAlign: "center" }}>
                                Community Cards
                              </div>
                              <div class="card-images" style={{ display: "flex", justifyContent: "center", gap: "3px", flexWrap: "wrap" }}>
                                <img src={imgval1} loading="lazy" style={{ width: "40px", height: "60px", objectFit: "cover", borderRadius: "5px" }} />

                              </div>
                            </div>
                          </td>
                        </tr>
                        <tr
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            justifyContent: "space-evenly",
                            background: "transparent"
                          }}
                        >
                          <td className="TdResults TdResultsWin">
                            <div
                              class="player-cards"
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                overflowWrap: "break-word"
                              }}
                            >
                              <div
                                class="player-name"
                                style={{
                                  fontWeight: "bold",
                                  textAlign: "center",
                                  width: "100%"
                                }}
                              >
                                {reusutlRnr1}
                              </div>
                              <div
                                class="card-images"
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  gap: "3px",
                                  flexWrap: "wrap",
                                  width: "100%"
                                }}
                              >
                                <img
                                  src="/assets/images/bpstudio/cards/card_simple_omaha_back_bf.svg"
                                  loading="lazy"
                                  style={{
                                    width: "40px",
                                    height: "60px",
                                    objectFit: "cover",
                                    borderRadius: "5px"
                                  }}
                                />
                              </div>
                              <div
                                className="player-status bgwinner"
                                style={{
                                  color: "rgb(0, 0, 0)",
                                  marginTop: "5px",
                                  fontSize: "14px",
                                  fontWeight: "bold",
                                  textAlign: "center",
                                  width: "100%"
                                }}
                              >
                                WINNER
                              </div>
                            </div>
                          </td>
                          <td className="TdResults TdResultsWin">
                            <div
                              class="player-cards"
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                overflowWrap: "break-word"
                              }}
                            >
                              <div
                                class="player-name"
                                style={{
                                  fontWeight: "bold",
                                  textAlign: "center",
                                  width: "100%"
                                }}
                              >
                                {reusutlRnr2}
                              </div>
                              <div
                                class="card-images"
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  gap: "3px",
                                  flexWrap: "wrap",
                                  width: "100%"
                                }}
                              >
                                <img
                                  src="/assets/images/bpstudio/cards/card_simple_omaha_back_bf.svg"
                                  loading="lazy"
                                  style={{
                                    width: "40px",
                                    height: "60px",
                                    objectFit: "cover",
                                    borderRadius: "5px"
                                  }}
                                />
                              </div>
                              <div
                                className="player-status bgwinner"
                                style={{
                                  color: "rgb(0, 0, 0)",
                                  marginTop: "5px",
                                  fontSize: "14px",
                                  fontWeight: "bold",
                                  textAlign: "center",
                                  width: "100%"
                                }}
                              >
                                WINNER
                              </div>
                            </div>
                          </td>
                          <td className="TdResults TdResultsWin">
                            <div
                              class="player-cards"
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                overflowWrap: "break-word"
                              }}
                            >
                              <div
                                class="player-name"
                                style={{
                                  fontWeight: "bold",
                                  textAlign: "center",
                                  width: "100%"
                                }}
                              >
                                {reusutlRnr3}
                              </div>
                              <div
                                class="card-images"
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  gap: "3px",
                                  flexWrap: "wrap",
                                  width: "100%"
                                }}
                              >
                                <img
                                  src="/assets/images/bpstudio/cards/card_simple_omaha_back_bf.svg"
                                  loading="lazy"
                                  style={{
                                    width: "40px",
                                    height: "60px",
                                    objectFit: "cover",
                                    borderRadius: "5px"
                                  }}
                                />
                              </div>
                              <div
                                className="player-status bgwinner"
                                style={{
                                  color: "rgb(0, 0, 0)",
                                  marginTop: "5px",
                                  fontSize: "14px",
                                  fontWeight: "bold",
                                  textAlign: "center",
                                  width: "100%"
                                }}
                              >
                                WINNER
                              </div>
                            </div>
                          </td>
                          <td className="TdResults TdResultsWin">
                            <div
                              class="player-cards"
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                overflowWrap: "break-word"
                              }}
                            >
                              <div
                                class="player-name"
                                style={{
                                  fontWeight: "bold",
                                  textAlign: "center",
                                  width: "100%"
                                }}
                              >
                                {reusutlRnr4}
                              </div>
                              <div
                                class="card-images"
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  gap: "3px",
                                  flexWrap: "wrap",
                                  width: "100%"
                                }}
                              >
                                <img
                                  src="/assets/images/bpstudio/cards/card_simple_omaha_back_bf.svg"
                                  loading="lazy"
                                  style={{
                                    width: "40px",
                                    height: "60px",
                                    objectFit: "cover",
                                    borderRadius: "5px"
                                  }}
                                />
                              </div>
                              <div
                                className="player-status bgwinner"
                                style={{
                                  color: "rgb(0, 0, 0)",
                                  marginTop: "5px",
                                  fontSize: "14px",
                                  fontWeight: "bold",
                                  textAlign: "center",
                                  width: "100%"
                                }}
                              >
                                WINNER
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            );
          })}


      </div>
    </div>
  );
}

export default BollywoodResult;
